<button *ngIf="buttonType=='square' && variablesService.social" mat-raised-button class="fb-btn btn-fb share-btn" (click)=facebookShare() [style.color]="color" [style.background-color]="backgroudColor">
  <mat-icon *ngIf="!isLoading" class="icon-fb" [style.color]="color"></mat-icon>
  <span *ngIf="label" class="label">{{label}}</span>
  <span class="fb-count" [style.color]="color" *ngIf="fundraiser?.fb_share_count?.info_1 && !isLoading">
    ({{fundraiser?.fb_share_count?.info_1 | abbreviateNumber}})
  </span>
  <span class="fb-count" [style.color]="color" *ngIf="count && !fundraiser?.fb_share_count?.info_1">
    ({{count | abbreviateNumber}})
  </span>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>

<button *ngIf="buttonType=='round' && variablesService.social" mat-icon-button class="fb-icon-btn fb btn-fb share-btn" (click)=facebookShare() [style.color]="color" [style.background-color]="backgroudColor">
  <mat-icon *ngIf="!isLoading" class="icon-facebook" [style.color]="color"></mat-icon>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>

<button *ngIf="buttonType=='link' && variablesService.social" mat-button class="fb-link btn-fb share-btn" (click)=facebookShare() [style.color]="color" [style.background-color]="backgroudColor">
  <i *ngIf="!isLoading" class="material-icons">share</i><strong *ngIf="!isLoading">Share Via Facebook</strong>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>

<button *ngIf="buttonType=='flat' && variablesService.social" mat-button class="fb-flat-btn btn-fb share-btn" (click)=facebookShare()>
  <i *ngIf="!isLoading" class="icon-facebook"></i>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>